import React from "react";
import ReactPaginate from "react-paginate";
import StyledLgText from "../../common/components/styledLgText/StyledLgText";
import IconifyIcon from "../icons/Icon";

function Pagination({ initialPage, pageCount, onPageChange }) {
  const previousLabel = (
    <div
      className={`text-black py-1.5 px-2.5 sm:pl-2 sm:pr-3 mr-2 flex items-center justify-center bg-transparent border border-regular-orange sm:border-0 sm:bg-regular-orange rounded-md`}
    >
      <div className="hidden sm:flex justify-center items-center gap-1">
        <div>
          <IconifyIcon icon="ic:baseline-keyboard-arrow-left"></IconifyIcon>
        </div>
        <StyledLgText fontColor={""}>Prev</StyledLgText>
      </div>
      <div className="flex justify-center items-center sm:hidden">
        <img
          src="/assets/pagination-arrow.svg"
          alt=""
          className={"rotate-180 w-5"}
        />
      </div>
    </div>
  );
  const NextLabel = (
    <div
      className={`text-black py-1.5 px-2.5 sm:pr-2 sm:pl-3 ml-2 flex gap-1 items-center justify-center
          bg-transparent border border-regular-orange sm:border-0 sm:bg-regular-orange rounded-md`}
    >
      <div className="hidden sm:flex justify-center items-center gap-1">
        <StyledLgText>Next</StyledLgText>
        <div>
          <IconifyIcon icon="ic:baseline-keyboard-arrow-right"></IconifyIcon>
        </div>
      </div>
      <div className="flex justify-center items-center  sm:hidden">
        <img src="/assets/pagination-arrow.svg" alt="" className={"w-5"} loading="lazy"/>
      </div>
    </div>
  );

  return (
    <>
      <ReactPaginate
        pageCount={pageCount}
        initialPage={initialPage}
        breakLabel={"..."}
        nextLabel={NextLabel}
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        previousLabel={previousLabel}
        onPageChange={onPageChange}
        containerClassName={"pagination"}
        previousLinkClassName={"pagination__link"}
        nextLinkClassName={"pagination__link"}
        disabledClassName={"pagination__link--disabled"}
        activeClassName={"pagination__link--active"}
      />
      <style>
        {`
          .pagination {
            display: flex;
            justify-content: center;
            align-items: center;
            list-style: none;
            padding: 0;
            gap: 10px;
            margin-top: 1.5rem;
          }
          .pagination__link--active a {
            color: black !important;
            background: var(--regular-orange);
            border-radius: 6px;
            padding: 6px 12px;
          }
          .pagination__link--disabled {
            opacity: 0.5; 
          }
          ul a {
            color: #E3E3E3;
          }
        `}
      </style>
    </>
  );
}

export default Pagination;
